export const sideSpace = '72px';

const propertigrabSpacing = {
    sideSpace,
};

export default propertigrabSpacing;
